/**
 * Platform detection and cross-platform keyboard shortcut display.
 *
 * Mac shows symbols (⌘, ⌥), Windows/Linux shows text labels (Ctrl, Alt).
 */

export const isMac =
  typeof navigator !== "undefined" && /Macintosh/.test(navigator.userAgent);

/**
 * Format a shortcut string for the current platform.
 *
 * On Mac, returns as-is (e.g. "⌥S", "⌘/").
 * On Windows/Linux, replaces symbols with text labels and adds "+" separators
 * (e.g. "Alt+S", "Ctrl+/").
 */
export function formatShortcut(shortcut: string): string {
  if (isMac) return shortcut;
  return shortcut.replace("⌥", "Alt+").replace("⌘", "Ctrl+");
}

/**
 * Map a modifier key name for display on the current platform.
 *
 * Used for shortcut definition arrays where keys are listed individually
 * (e.g. ["⌥", "S"] → ["Alt", "S"] on Windows).
 */
export function formatModifierKey(key: string): string {
  if (isMac) return key;
  if (key === "⌥") return "Alt";
  if (key === "⌘") return "Ctrl";
  return key;
}
